import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { Slices } from 'ducks/slices';
import { Andromeda } from 'utils/axios';
import { handleError } from 'utils/errors';

export const getSystemParameters = createAsyncThunk<string[]>(
  `${Slices.SYSTEM_PARAMETERS_LIST}/get`,
  async (_, { rejectWithValue }) => {
    try {
      const res: AxiosResponse['data'] = await Andromeda.get('/lookups/systems/parameters');
      return res.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error as AxiosError);
    }
  },
);
